var map = {
	"./wvt-s-001.jpg": 7705,
	"./wvt-s-0010.jpg": 805,
	"./wvt-s-0011.jpg": 3544,
	"./wvt-s-0012.jpg": 2471,
	"./wvt-s-0013.jpg": 3466,
	"./wvt-s-0014.jpg": 6057,
	"./wvt-s-0015.jpg": 8684,
	"./wvt-s-002.jpg": 8110,
	"./wvt-s-003.jpg": 9419,
	"./wvt-s-004.jpg": 1480,
	"./wvt-s-005.jpg": 5445,
	"./wvt-s-006.jpg": 1242,
	"./wvt-s-007.jpg": 8759,
	"./wvt-s-008.jpg": 548,
	"./wvt-s-009.jpg": 8593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2533;